import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import UserDropdown from './header/UserDropdown';
import MobileMenu from './header/MobileMenu';
import DesktopNav from './header/DesktopNav';
import MobileProfileButton from './mobile/MobileProfileButton';
import LanguageSwitcher from './LanguageSwitcher';
import RequestDialog from './dashboard/RequestDialog';
import { useAuth } from '@/providers/AuthProvider';
import { useIsMobile } from '@/hooks/use-mobile';
import { useDirection } from '@/providers/DirectionProvider';
const Header = () => {
  const { t } = useTranslation();
  const { direction } = useDirection();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isRequestDialogOpen, setIsRequestDialogOpen] = useState(false);
  const {
    user,
    signOut
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);
  const handleLoginClick = () => {
    navigate('/login');
  };
  const handleLogout = () => {
    signOut();
    navigate('/');
  };
  const handleSendRequest = () => {
    setIsRequestDialogOpen(true);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 pt-[env(safe-area-inset-top)] ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/80 backdrop-blur-sm py-3'}`}>
      <div className="container mx-auto flex items-center justify-between px-[23px]">
        <Link to="/" className="flex items-center">
          <img alt="Ofair Logo" src="/logo-new.png" width={96} height={96} loading="eager" fetchPriority="high" className="h-20 sm:h-24 animate-fade-in object-contain" />
        </Link>

        <DesktopNav onSendRequest={handleSendRequest} />

        <div className="flex items-center gap-2 sm:gap-4 animate-fade-in">
          <LanguageSwitcher variant="minimal" className="hidden sm:flex" />

          <a href="https://biz.ofair.co.il" target="_blank" rel="noopener noreferrer" className="hidden md:inline-block text-xs text-teal-600 hover:text-teal-700 py-1 px-3 border border-teal-500 rounded-md hover:bg-teal-50 transition-colors">
            {t('header.professionalJoin')}
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex">
            {user ? <UserDropdown onLogout={handleLogout} /> : <Button variant="ghost" className="flex items-center gap-2 text-blue-700 hover:text-blue-800 hover:bg-blue-50" onClick={handleLoginClick}>
                <User size={18} />
                <span>{t('header.login')}</span>
              </Button>}
          </div>

          {/* Mobile Profile Button */}
          <div className="md:hidden flex items-center gap-2">
            <LanguageSwitcher variant="icon" className="sm:hidden" />
            <MobileProfileButton onLogout={handleLogout} />
          </div>
        </div>
      </div>

      <RequestDialog 
        isOpen={isRequestDialogOpen} 
        onOpenChange={setIsRequestDialogOpen}
      />
    </header>;
};
export default Header;